/*
* @Author: zhangzhitao
* @Date: 2019-06-11 20:00:28
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-06-11 20:02:56
*/

<template>
  <div class="m-widget-bar">
    <el-scrollbar
      wrap-class="m-scrollbar-wrap"
      view-class="m-scroll-view"
      ref="compsScroll"
      @on-scrolling-x="handleLogScroll"
      tag="ul"
    >
      <li
        class="m-widget-card"
        :title="item.name"
        :key="item.id"
        :class="[
                    item.type,
                    item.subType,
                    { template: typeTag === 'model' }
                  ]"
        v-for="(item, i) in realComps"
      >
        <div
          class="m-widget-cover"
          @mousedown="dragIn(i, $event, item)"
        ></div>
        <div class="m-widget-head">
          {{ item.name }}
        </div>
        <i
          class="u-utils u-utils-eye1"
          v-if="typeTag === 'widget'"
          @mousedown.stop
          @click.stop="
                      dialogPreview = true;
                      previewWidget = item;
                    "
        ></i>
        <i
          class="u-utils h-icon-trashcan"
          v-if="typeTag === 'model'"
          @mousedown.stop
          @click.stop="handleDeleteModel(item.id)"
        ></i>
      </li>
      <li
        class="m-seize-seat"
        :class="{ 'no-data': realComps.length === 0 }"
        :style="`width:${seizeSeatWidth}px;`"
      >
        <span v-if="realComps.length === 0">{{
          typeTag === "widget"
          ? $t("management.home.no_widgets")
          : $t("management.home.no_modules")
          }}</span>
      </li>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'waterfall-card'
}
</script>
